export default {
    scheme: 'spacemacs',
    author: 'Nasser Alshammari (https://github.com/nashamri/spacemacs-theme)',
    base00: '#1f2022',
    base01: '#282828',
    base02: '#444155',
    base03: '#585858',
    base04: '#b8b8b8',
    base05: '#a3a3a3',
    base06: '#e8e8e8',
    base07: '#f8f8f8',
    base08: '#f2241f',
    base09: '#ffa500',
    base0A: '#b1951d',
    base0B: '#67b11d',
    base0C: '#2d9574',
    base0D: '#4f97d7',
    base0E: '#a31db1',
    base0F: '#b03060',
};
